export const ListAndDetailSamplesBasicPageInfo = () => {
    return (
        <>
            This shows the basic usage of how to use the list. <br />
            It is responsive as well, the view in mobile looks quite different than desktop and is optomised for a better mobile experience.<br />
            <br />
            <br/>
            Note that the library cannot initiate correct values of hooks, components from react-router-dom.<br />
            They have to be passed into the ListAndDetail component. See the code example of how to do this. <br />
            <br />
            Source code location:<br />
            <i>'src/components/listAndDetailSamples/listAndDetailSamplesPages/listAndDetailSamplesBasicPage'</i>
        </>
    )
}
